import React from 'react';
import { Icon, Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import './DecisionLabel.css';

function DecisionLabel({ value, label, iconKind, description }) {
  return (
    <div className='DecisionLabel-item'>
      <Typography kind='body1' className='DecisionLabel-itemCount'>
        {value}
      </Typography>
      <Icon
        kind={iconKind}
        color='navy-900'
        size='small'
        className='DecisionLabel-itemIcon'
      />
      <Typography kind='body2' className='DecisionLabel-itemLabel'>
        {label}
        <span className='DecisionLabel-notify'>
          {description && description}
        </span>
      </Typography>
    </div>
  );
}

DecisionLabel.propTypes = {
  value: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  iconKind: PropTypes.string.isRequired,
  description: PropTypes.string,
};

DecisionLabel.defaultProps = { description: '' };

export default DecisionLabel;
